<template>
    <div>
        <div id="dashboard" class="textCenter">
            <h2 v-if="loggedIn">Welcome Back!</h2>
            <h2 v-else>Welcome!</h2>
            <p>Upload a configuration to start using CONF.</p>

            <div class="form">
                <ul>
                    <li class="upload">
                        <div class="uploadContainer" @drop.prevent="getDrop" @dragover.prevent>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#00ADB5" d="M12.5,25C19.4,25,25,19.4,25,12.5S19.4,0,12.5,0S0,5.6,0,12.5S5.6,25,12.5,25z M14,17.5c0,0.3-0.2,0.5-0.5,0.5h-2c-0.3,0-0.5-0.2-0.5-0.5v-1c0-0.3,0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5V17.5z M8.7,11.1l3.5-3.9c0.2-0.2,0.5-0.2,0.7,0l0,0l3.5,3.9c0.2,0.2,0.2,0.5,0,0.7c-0.1,0.1-0.2,0.1-0.3,0.1h-2v2.6c0,0.3-0.2,0.5-0.5,0.5h-2.1c-0.3,0-0.5-0.2-0.5-0.5v-2.6H9c-0.3,0-0.5-0.2-0.5-0.5C8.5,11.3,8.6,11.2,8.7,11.1z"/></svg>
                            <span>Drag your file here to upload, or <a  @click="toggleUpload" class="uploadConf" title="Browse Files">browse files</a> from your computer.</span>
                            <a class="btn" title="Choose File" @click="toggleUpload">Choose File</a>
                        </div>
                        <input id="uploadConf" type="file" ref="file" @change="getFile" required>
                    </li>
                </ul>
            </div>

            <div class="or">
              <span>OR</span>
            </div>

            <template v-if="loggedIn">
              <h2>Create a new configuration</h2>
              <p>Create a new configuration from scratch.</p>
              <router-link to="/manage/config/action/create" class="btn" title="New configuration">New configuration</router-link>
            </template>
            <a v-else :href="loginUrl" class="btn noMargin" title="Sign Up / Sign In">Sign up / Sign in</a>
        </div>
    </div>
</template>

<script>
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import store from '../store'
  import router from '../router'
  import { mixin } from '../components/mixins/mixin'


  export default {
    name: 'ConfDashboard',

    mixins: [mixin],

    data: function() {
      return {
        file: null,
      }
    },

    computed: {
      loggedIn() {
        return store.state.authToken.length
      }
    },

    methods: {
      getDrop() {
        this.file = event.dataTransfer.files[0];
        this.uploadFile()
      },

      getFile() {
        this.file = this.$refs.file.files[0];
        this.uploadFile()
      },

      toggleUpload() {
        $('#uploadConf').click()
      },

      uploadFile() {
        let vc = this;

        const formData = new FormData()
        formData.append('file', vc.file)

        $('#loader').fadeIn()

        axios.
        post(process.env.VUE_APP_API_URL+'/validate/postgresql.conf', formData)
        .then( function(response){

          if(vc.loggedIn) {
            var count = store.state.configs.length+1;
            axios
            .post(process.env.VUE_APP_API_URL+'/configs', {
                name: 'Untitled Configuration '+count,
                pgVersion: response.data.version
              },
              {
                headers: {
                  'Authorization': 'Bearer '+store.state.authToken
                }
              }
            )
            .then( function(response) { // Add postgresql.conf file
              const configId = response.data.configId;

              axios
              .post(process.env.VUE_APP_API_URL+'/configs/'+configId+'/postgresql.conf', formData, {
                  headers: {
                      'Authorization': 'Bearer '+store.state.authToken,
                      'Content-Type': 'multipart/form-data'
                  }
                }
              )
              .then( function(response){
                // Reload configs
                vc.fetchConfigs()

                //var configs = response.data.configs;
                vc.notify('<p>Configuration successfuly validated</p>', true)
                router.push('/manage/config/'+configId)
              }).catch(function(err) {
                vc.notify('<p>There was an error trying to validate your configuration.</p>', false, 'error')
                console.log(err);
              });

            }).catch(function(err) {
              console.log(err);
            });
          } else {
            store.commit('setDemoConfig', response.data);
            router.push('/manage/config/action/validate')
          }
        }).catch(function(err) {
            console.log(err);
        });
      }

    },
    mounted: function() {
      const vc = this;

      /* $(document).on('click','.uploadConf', function() {
        $('#uploadConf').click()
      }) */
    }

  }

</script>


<style scoped>

.open.settings #main {
    width: calc(100vw - 400px);
}

</style>
